import { Controller } from "stimulus"

export default class extends Controller {

  static targets = [ "all", "count", "checkbox" ]
  static values = { count: Number }

  connect() {
    this.countValue = this.checkboxTargets.filter(el => el.classList.contains("checked")).length
  }

  toggle(e) {

    if (this.allTargets.includes(e.currentTarget)) {

      this.checkboxTargets.forEach((el) => {

        if (!e.currentTarget.classList.contains("checked")) {
          el.classList.add("checked")
        } else {
          el.classList.remove("checked")
        }
      })

    } else {
      e.currentTarget.classList.toggle("checked")
    }

    this.countValue = this.checkboxTargets.filter(el => el.classList.contains("checked")).length
  }

  keydown(e) {

    if (e.which == 13 || e.which == 32) {
      this.toggle(e)
      e.preventDefault()
    }

  }

  countValueChanged() {
    this.countTargets.forEach((el) => {
      el.innerHTML = `(${this.countValue})`
    })

    this.allTargets.forEach((el) => {
      if (this.countValue > 0 && this.checkboxTargets.length == this.countValue) {
        el.classList.add("checked")
      } else {
        el.classList.remove("checked")
      }
    })

    const event = document.createEvent("CustomEvent")
    event.initCustomEvent("check-all-count-value-changed", true, true, null)
    this.element.dispatchEvent(event)
  }

}